export const STRIPE_CREATE_SESSION_REQUEST = "STRIPE_CREATE_SESSION_REQUEST";
export const STRIPE_CREATE_SESSION_SUCCESS = "STRIPE_CREATE_SESSION_SUCCESS";
export const STRIPE_CREATE_SESSION_FAILURE = "STRIPE_CREATE_SESSION_FAILURE";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAILURE = "STRIPE_PAYMENT_FAILURE";

export interface StripeState {
  status: boolean;
  success: boolean;

  paymentDetails: any;  // Replace `any` with the actual type of payment data


  sessionId: string | null;
  loading: boolean;
  error: string | null;
}

interface StripeCreateSessionRequest {
  type: typeof STRIPE_CREATE_SESSION_REQUEST;
}

interface StripeCreateSessionSuccess {
  type: typeof STRIPE_CREATE_SESSION_SUCCESS;
  payload: { sessionId: string, bookingData: any };
}

interface StripeCreateSessionFailure {
  type: typeof STRIPE_CREATE_SESSION_FAILURE;
  payload: string;
}

interface StripePaymentSuccess {
  type: typeof STRIPE_PAYMENT_SUCCESS;
  payload: { status: boolean };
}

interface StripePaymentFailure {
  type: typeof STRIPE_PAYMENT_FAILURE;
  payload: string;
}

export type StripeActionTypes =
  | StripeCreateSessionRequest
  | StripeCreateSessionSuccess
  | StripeCreateSessionFailure
  | StripePaymentSuccess
  | StripePaymentFailure
  ;
